import * as Request from 'request-promise'
import { environment } from '../environments/index'

import * as _ from 'lodash'

export class SuperAdminService {
    constructor() {
    }
    baseUrl(path = '') {
        return `${environment.production.host}/api/${environment.production.version}/superAdmin/${path}`
    }
    async exec(options) {
        try {
            return await Request(options)
        } catch (err) {
            console.log("err: ", err)
            throw err
        }
    }
    async upgradeLicense(superToken, appId, packageLicense, option = {}) {
        const options = {
            uri: this.baseUrl('upgrade'),
            method: "POST",
            qs: this._paserQuery(option.query),
            headers: _.merge({
                'User-Agent': 'Request-Promise',
                'Content-Type': "Application/json",
                'super_token': superToken
            }, option.headers),
            body: {
                appId, packageLicense
            },
            json: true
        }
        const res = await this.exec(options)
        return res.results.object
    }
    async getApps(superToken, option = {}) {
        const options = {
            uri: this.baseUrl('apps'),
            method: "GET",
            qs: this._paserQuery(option.query),
            headers: _.merge({
                'User-Agent': 'Request-Promise',
                'Content-Type': "Application/json",
                'super_token': superToken
            }, option.headers),
            json: true
        }
        const res = await this.exec(options)
        return res.results.objects.rows
    }
    async login(firebaseToken, option = {}) {
        const options = {
            uri: this.baseUrl('login'),
            method: "POST",
            qs: this._paserQuery(option.query),
            headers: _.merge({
                'User-Agent': 'Request-Promise',
                'Content-Type': "Application/json",
                'access_token': firebaseToken,
            }, option.headers),
            body: {},
            json: true
        }
        const res = await this.exec(options)
        return res.results.object
    }
    _paserQuery(query = {}) {
        let parsedQuery = _.merge({}, query)
        if (query.filter) {
            parsedQuery.filter = JSON.stringify(query.filter);
        }
        if (query.order) {
            parsedQuery.order = JSON.stringify(query.order);
        }
        if (query.scopes) {
            parsedQuery.scopes = JSON.stringify(query.scopes);
        }
        if (query.fields) {
            parsedQuery.fields = JSON.stringify(query.fields);
        }
        if (query.items) {
            parsedQuery.items = JSON.stringify(query.items);
        }
        if (query.populates) {
            parsedQuery.populates = JSON.stringify(query.populates)
        }
        if (query.limit) {
            parsedQuery.limit = JSON.stringify(query.limit)
        }
        if (query.offset) {
            parsedQuery.offset = JSON.stringify(query.offset)
        }
        return parsedQuery;
    }

}


// WEBPACK FOOTER //
// ./src/services/admin.js